module.exports = __webpack_public_path__ + "green.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/skins/flat/green.png
// module id = 1187
// module chunks = 0